import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// راه‌اندازی i18n (تشخیص زبان از دامنه/ساب‌دامنه + جهت RTL). باید قبل از رندر
// اپ import شود تا زبان اولیه و dir صفحه ست شوند.
import './i18n/config';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
